import React from "react";
import { Briefcase, Calendar, Clock } from "lucide-react";
import { Card, SearchInput, SegmentedControl, Table, Badge, TablePagination } from "../../../components/ui";

const LoanTable = ({
  loanSearch,
  setLoanSearch,
  loanDateFilter,
  handleLoanDateFilterChange,
  loanFilter,
  handleLoanFilterChange,
  searchedLoanList,
  collectedTotal,
  pendingTotal,
  paginatedLoanList,
  loanPage,
  setLoanPage,
  totalLoanPages,
  ITEMS_PER_PAGE
}) => {
  return (
    <Card>
      <Card.Header
        title={
          <div className="flex items-center gap-2">
            <Briefcase size={18} className="text-primary-500" />
            <span>Loan Details</span>
          </div>
        }
        actions={
          <div className="flex flex-wrap items-center gap-3 w-full lg:w-auto">
            <SearchInput
              placeholder="Search customer..."
              value={loanSearch}
              onChange={(e) => {
                setLoanSearch(e.target.value);
                setLoanPage(1);
              }}
            />
            
            <SegmentedControl
              value={loanDateFilter}
              onChange={handleLoanDateFilterChange}
              options={[
                { value: "Yesterday", label: "Yesterday", icon: <Clock size={12} /> },
                { value: "Today", label: "Today", icon: <Calendar size={12} /> },
                { value: "Tomorrow", label: "Tomorrow", icon: <Clock size={12} /> },
              ]}
            />

            <SegmentedControl
              value={loanFilter}
              onChange={handleLoanFilterChange}
              options={[
                { value: "All", label: "All" },
                { value: "Pending", label: "Pending" },
                { value: "Received", label: "Received" },
              ]}
            />

            <span className="text-xs font-bold text-ink-700 bg-canvas px-2.5 py-1.5 rounded-lg border border-border whitespace-nowrap">
              {searchedLoanList.length} Found
            </span>
          </div>
        }
      />
      <Card.Body>
        <div className="flex gap-4 mb-4 p-3 bg-canvas border border-border rounded-lg text-xs font-semibold">
          <div className="flex items-center gap-1.5">
            <span className="w-2 h-2 rounded-full bg-success-500" />
            <span className="text-ink-500">Collected:</span>
            <span className="text-success-600 font-bold">₹{collectedTotal.toLocaleString("en-IN")}</span>
          </div>
          <div className="flex items-center gap-1.5">
            <span className="w-2 h-2 rounded-full bg-danger-500" />
            <span className="text-ink-500">Pending:</span>
            <span className="text-danger-600 font-bold">₹{pendingTotal.toLocaleString("en-IN")}</span>
          </div>
        </div>
        
        <Table>
          <Table.Head>
            <tr>
              <Table.HeadCell>S.No</Table.HeadCell>
              <Table.HeadCell>Customer</Table.HeadCell>
              <Table.HeadCell>Amount</Table.HeadCell>
              <Table.HeadCell>Phone</Table.HeadCell>
              <Table.HeadCell>Status</Table.HeadCell>
            </tr>
          </Table.Head>
          <Table.Body>
            {paginatedLoanList.length > 0 ? (
              paginatedLoanList.map((loan, index) => (
                <Table.Row key={index} status={loan.received.toLowerCase() === "received" ? "received" : "rejected"}>
                  <Table.Cell>
                    {(loanPage - 1) * ITEMS_PER_PAGE + index + 1}
                  </Table.Cell>
                  <Table.Cell className="font-medium">{loan.customerName || "N/A"}</Table.Cell>
                  <Table.AmountCell>
                    {loan.total || 0}
                  </Table.AmountCell>
                  <Table.Cell className="font-medium">{loan.mobileNumber || "N/A"}</Table.Cell>
                  <Table.Cell>
                    <Badge variant={loan.received.toLowerCase() === "received" ? "success" : "danger"} dot>
                      {loan.received || "Unknown"}
                    </Badge>
                  </Table.Cell>
                </Table.Row>
              ))
            ) : (
              <Table.EmptyRow colSpan={5} message="No loan details available" />
            )}
          </Table.Body>
        </Table>

        <TablePagination
          currentPage={loanPage}
          totalPages={totalLoanPages}
          totalEntries={searchedLoanList.length}
          itemsPerPage={ITEMS_PER_PAGE}
          onPageChange={setLoanPage}
        />
      </Card.Body>
    </Card>
  );
};

export default LoanTable;
